import styles from './Error.module.css'

function ErrorMessage() {
  return (
    <>
      <h1 className={styles.centered}>Error</h1>
      <div>
        CourseKit that is hosting the course content is having a problem. I have
        contacted them and am waiting for a response. Sorry for this downtime.
      </div>
      <div className={styles.signed}>Gleb</div>
    </>
  )
}

export default ErrorMessage
